import * as Form from '../../Form';
import { LegalComplianceSectionBase } from '../../dapp-form/sections/LegalComplianceSectionBase';
import type { FormState, NewDappInputChangeEvent } from '../types';

interface LegalComplianceSectionProps {
  formData: FormState;
  onInputChange: (event: NewDappInputChangeEvent) => void;
}

export function LegalComplianceSection({
  formData,
}: LegalComplianceSectionProps) {
  return (
    <LegalComplianceSectionBase
      legalUrlFields={
        <>
          <Form.UrlInput
            label="Terms of Use"
            explanation="Public link to your app's consumer-facing Terms of Use"
            name="licenseUrl"
            placeholder="https://"
            defaultValue={formData.licenseUrl}
            validateHttps={true}
          />
          <Form.UrlInput
            label="Privacy Policy"
            explanation="Public link to your app's consumer-facing Privacy Policy explaining data collection and protection."
            name="privacyPolicyUrl"
            placeholder="https://"
            defaultValue={formData.privacyPolicyUrl}
            validateHttps={true}
          />
        </>
      }
    />
  );
}
